"use strict";
/**
 * @description video 菜单 panel tab 配置
 * @author tonghan,darin_l
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = require("../../utils/util");
var dom_core_1 = __importDefault(require("../../utils/dom-core"));
var upload_video_1 = __importDefault(require("./upload-video"));
var const_1 = require("../../utils/const");
function default_1(editor, video) {
    var config = editor.config;
    var uploadVideo = new upload_video_1.default(editor);
    // panel 中需要用到的id
    var upVideoTriggerId = util_1.getRandom('up-video-trigger-id');
    var upVideoId = util_1.getRandom('up-video-id');
    var inputVideoLinkId = util_1.getRandom('input-video-link');
    var videoLinkBtnId = util_1.getRandom('video-link-btn');
    var i18nPrefix = 'menus.panelMenus.video.';
    var t = function (text, prefix) {
        if (prefix === void 0) { prefix = i18nPrefix; }
        return editor.i18next.t(prefix + text);
    };
    /**
     * 提示信息
     * @param alertInfo alert info
     * @param debugInfo debug info
     */
    function alert(alertInfo, debugInfo) {
        var customAlert = editor.config.customAlert;
        if (customAlert) {
            customAlert(alertInfo);
        }
        else {
            window.alert(alertInfo);
        }
        if (debugInfo) {
            console.error('wangEditor: ' + debugInfo);
        }
    }
    /**
     * 校验网络视频链接是否合法
     * @param src 网络视频链接
     */
    function checkLinkVideo(src) {
        //编辑器进行正常校验，视频合规则使指针为true，不合规为false
        var flag = true;
        if (!const_1.videoRegex.test(src)) {
            flag = false;
        }
        //查看开发者自定义配置的返回值
        var check = config.linkVideoCheck(src);
        if (check === undefined) {
            //用户未能通过开发者的校验，且开发者不希望编辑器提示用户
            if (flag === false)
                console.log(t('您刚才插入的视频链接未通过编辑器校验', 'validate.'));
        }
        else if (check === true) {
            //用户通过了开发者的校验
            if (flag === false) {
                alert(t('您插入的网络视频无法识别', 'validate.') + "\uFF0C" + t('请替换为支持的视频类型', 'validate.') + "\uFF1Amp4 | rmvb | wma | avi | mov");
            }
            else
                return true;
        }
        else {
            //用户未能通过开发者的校验，开发者希望我们提示这一字符串
            alert(check);
        }
        return false;
    }
    // tabs 配置 -----------------------------------------
    var fileMultipleAttr = config.uploadVideoMaxLength === 1 ? '' : 'multiple="multiple"';
    var tabsConf = [
        {
            // table 的标题
            title: t('上传视频'),
            // 模板
            tpl: "<div class=\"w-e-up-img-container\">\n                    <div id=\"" + upVideoTriggerId + "\" class=\"w-e-up-btn\">\n                        <i class=\"w-e-icon-upload2\"></i>\n                    </div>\n                    <div style=\"display:none;\">\n                        <input id=\"" + upVideoId + "\" type=\"file\" " + fileMultipleAttr + " accept=\"video/mp4, video/rmvb, video/wma, video/avi, video/mov\"/>\n                    </div>\n                </div>",
            // 事件绑定
            events: [
                //触发选择视频
                {
                    selector: '#' + upVideoTriggerId,
                    type: 'click',
                    fn: function () {
                        var $file = dom_core_1.default('#' + upVideoId);
                        var fileElem = $file.elems[0];
                        if (fileElem) {
                            fileElem.click();
                        }
                        else {
                            // 返回 true 可关闭 panel
                            return true;
                        }
                    },
                },
                // 选择视频完毕
                {
                    selector: '#' + upVideoId,
                    type: 'change',
                    fn: function () {
                        var $file = dom_core_1.default('#' + upVideoId);
                        var fileElem = $file.elems[0];
                        if (!fileElem) {
                            // 返回 true 可关闭 panel
                            return true;
                        }
                        // 获取选中的 file 对象列表
                        var fileList = fileElem.files;
                        if (fileList.length) {
                            uploadVideo.uploadVideo(fileList);
                        }
                        // 返回 true 可关闭 panel
                        return true;
                    },
                },
            ]
        },
        {
            // tab 的标题
            title: t('网络视频'),
            // 模板
            tpl: "<div>\n                    <input \n                        id=\"" + inputVideoLinkId + "\" \n                        type=\"text\" \n                        class=\"block\" \n                        placeholder=\"" + t('视频链接') + "\"/>\n                    </td>\n                    <div class=\"w-e-button-container\">\n                        <button type=\"button\" id=\"" + videoLinkBtnId + "\" class=\"right\">\n                            " + t('插入', '') + "\n                        </button>\n                    </div>\n                </div>",
            // 事件绑定
            events: [
                // 插入视频
                {
                    selector: '#' + videoLinkBtnId,
                    type: 'click',
                    fn: function () {
                        // 执行插入视频
                        var $video = dom_core_1.default('#' + inputVideoLinkId);
                        var url = $video.val().trim();
                        // 视频为空，则不插入
                        if (!url)
                            return;
                        //如果不能通过校验也直接返回
                        if (!checkLinkVideo(url))
                            return;
                        uploadVideo.insertVideo(url);
                        // 返回 true，表示该事件执行完之后，panel 要关闭。否则 panel 不会关闭
                        return true;
                    },
                },
            ],
        },
    ]; // tabs end
    // 最终的配置 -----------------------------------------
    var conf = {
        width: 300,
        height: 0,
        tabs: [],
    };
    // 显示“上传视频”
    if (window.FileReader &&
        (config.uploadVideoServer || config.customUploadVideo)) {
        conf.tabs.push(tabsConf[0]);
    }
    // 显示“插入网络视频”
    if (config.showLinkVideo) {
        conf.tabs.push(tabsConf[1]);
    }
    return conf;
}
exports.default = default_1;
